import { useNavigate } from "react-router-dom"
import { ReactComponent as Plus } from "../../assets/icons/shapes/plus.svg"
import { useEffect } from "react";


const MainPageLayout = ({ title, buttonTitle, buttonLink, children, backButton, sectionTitle, isDate ,customClass }) => {
    
    const navigate = useNavigate();
    useEffect(()=>{
        document.title = title ?  title + " | پنل ادمین زیبا آکادمی" : sectionTitle + " | پنل ادمین زیبا آکادمی"
    },[])

    return (
        <div className='transaction-container !flex flex-col'>
            <div className="flex justify-between px-2 py-4 items-center wsm:flex-col wsm:pb-0">
                <h1 className=" text-3xl font-bold wsm:mb-4 text-center">{title}</h1>
                {
                    buttonTitle ?
                        <button className="flex text-xl text-white font-bold px-6 items-center py-4 rounded-2xl bg-bs-yellow"
                            onClick={() => navigate(buttonLink)} >
                            {buttonTitle}
                            <span className="px-2"><Plus width={24} height={24} /></span>
                        </button>
                        :
                        <></>
                }
                {
                    isDate ?
                        <div className='flex flex-col text-xl items-center font-bold pl-6'>
                            <p>تاریخ امروز</p>
                            <p>
                                {new Date().toLocaleDateString('fa-IR')}
                            </p>
                        </div>
                        :
                        <></>
                }
            </div>
            <div className="transaction-list-container active-primary-box  !min-h-[75%] !h-full wsm:!px-1">
                <div className="flex justify-between items-center wsm:items-start">
                    {sectionTitle && <h3 className="text-black text-xl">{sectionTitle}</h3>}
                    {backButton && <button className="px-7 py-4  relative -top-5 -left-5 rounded-tl-lg rounded-br-3xl text-white bg-slate-400"
                        onClick={() => navigate(-1)} >بازگشت</button>}
                </div>
                <div className={`p-2 flex flex-col h-full `+ customClass || "" }>
                    {
                        children
                    }
                </div>
            </div>
        </div>
    )
}

export default MainPageLayout